import { LineChart } from "@mui/x-charts";
import { SeriesValueFormatterContext } from "@mui/x-charts/models/seriesType/common";
import { aggregateYearlyData } from "src/calculators/juros-compostos/utils/functions";
import { normalSanatizerBRL } from "src/utils/functions";

function valueFormatter(value: string) {
  let response = Number(value).toFixed(0).replace(".", ",");
  response = response.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");

  if (response.length > 5) {
    response = response.slice(0, -4) + "k";
  }
  return response;
}

interface SimpleInterestResults {
  monthlyInterest: number[];
  monthlyAccumulated: number[];
  principal: number;
  months: number;
}

export function SimpleInterestGraph({
  results,
}: {
  results: SimpleInterestResults;
}) {
  const isHighDataVolume = results.monthlyInterest.length > 60;
  const displayMonthlyData = !isHighDataVolume;

  const dataAccumulatedInterest = displayMonthlyData
    ? results.monthlyAccumulated
    : aggregateYearlyData(results.monthlyAccumulated);

  // Create array with length matching the accumulated interest array
  const initialInvestment = Array(dataAccumulatedInterest.length).fill(results.principal);
  const dataInvested = displayMonthlyData
    ? initialInvestment
    : aggregateYearlyData(initialInvestment);

  const actualNumberInGraph = displayMonthlyData
    ? results.monthlyAccumulated
    : aggregateYearlyData(results.monthlyAccumulated);

  return (
    <div className="w-full min-w-[300px] min-h-[300px] h-[300px] sm:h-[400px] md:h-[600px] overflow-auto -ml-2 sm:ml-0">
      <LineChart
        colors={["#8d0202", "#000"]}
        grid={{ vertical: false, horizontal: true }}
        yAxis={[
          {
            valueFormatter: (value) => valueFormatter(value),
          },
        ]}
        series={[
          {
            // total em juros
            data: actualNumberInGraph,
            valueFormatter: (
              value: number | null,
              context: SeriesValueFormatterContext
            ) => {
              if (value === null) {
                return "N/A";
              }
              const index = context.dataIndex;
              let correspondingInterest = 0;
              if (displayMonthlyData) {
                correspondingInterest = results.monthlyInterest[index] ?? 0;
              } else {
                correspondingInterest = dataAccumulatedInterest[index] ?? 0;
              }
              return (
                "R$ " +
                normalSanatizerBRL(Number(correspondingInterest.toString()))
              );
            },
            label: "Total em juros",
          },
          {
            // valor investido
            data: dataInvested,
            valueFormatter: (value: number | null) => {
              if (value === null) {
                return "N/A";
              }
              return (
                "R$ " + normalSanatizerBRL(Number(value.toFixed(2))).toString()
              );
            },
            label: "Valor Investido",
          },
        ]}
      />
    </div>
  );
}